"use client"

import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"

/**
 * Display-only. Clerk owns the profile image, so changing it happens in
 * Clerk's <UserProfile> modal — this component used to carry a file input,
 * size/type validation, a crop dialog and an upload to Convex storage, all of
 * which now duplicate something Clerk already does and had no production users.
 */
interface UserAvatarProps {
  avatarUrl?: string | null
  name?: string | null
  size?: "sm" | "md" | "lg" | "xl"
}

export function UserAvatar({ avatarUrl, name, size = "md" }: UserAvatarProps) {
  const sizeClasses = {
    sm: "h-8 w-8",
    md: "h-10 w-10",
    lg: "h-16 w-16",
    xl: "h-20 w-20",
  }

  return (
    <Avatar className={sizeClasses[size]}>
      <AvatarImage src={avatarUrl || undefined} alt={name || "User avatar"} />
      <AvatarFallback>{name?.charAt(0)?.toUpperCase()}</AvatarFallback>
    </Avatar>
  )
}
